import { defineComponent as _defineComponent } from 'vue'
import {
  HeadingDisplay,
  BaseText,
  CopyButton,
  Heading
} from '@warrenbrasil/nebraska-web';
import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { IPixInfo } from '@/modules/cash/services/cash';
import { computed } from 'vue';

interface Props {
  pixInfo: IPixInfo | null;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PixSection',
  props: {
    pixInfo: null
  },
  setup(__props: any) {

const props = __props as {
  pixInfo: IPixInfo | null;
}



const getQrCodeBase = computed(() => {
  return `data:image/png;base64,${props.pixInfo?.pixQrCode}`;
});

return { __sfc: true,props, getQrCodeBase, HeadingDisplay, BaseText, CopyButton, Heading, NebraskaColors }
}

})